import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  background: '#f1efe4',
  inputBackground: constants.Colors.newBackground,
  activeButton: constants.Colors.Green,
  disableButton: constants.Colors.disable,
  termsAndCondition: '#1a1f3f',
  prefix: '#92afd6',
  submitBtnActiveBG: '#005089',
  submitBtnInActiveBG: '#484e6d',
  buttonLabel: '#fff',
  signWithEmailLabel: '#1a1f3f',
  signWithEmailBtn: '#1a1f3f',
  button: '#235dd4',
  forgotPasswordText: '#1a1f3f',
  dontHaveAccountText: '#fff',
  headerTitle: '#1a1f3f',
  headerBackTitle: '#1a1f3f',
  screenTitle: '#1a1f3f',
  screenSubTitle: '#7689b4',
  didntReceiveOtpLabel: '#7689b4',
  otpBoxInputText: '#1a1f3f',
  otpBoxInputBG: '#fff',
  otpBoxBorder: '#e92c81',
  radioButtonSelected: '#7d94b4',
  radioButtonUnSelected: '#7d94b4',
  radioButtonInnerCircle: '#235dd4',
  resetPasswordButton: '#235dd4',
  authHeader: '#f1efe4',
  changePasswordContainer: constants.Colors.DarkPurple,
  changePasswordBtn: constants.Colors.Blue,
  changePasswordTextInput: constants.Colors.DarkPurple,
  loginTextInputPlaceholder: '#555a78',
  loginTextInputPrimary: '#555a78',

  //for sign up with phone
  signUpPhoneBG: '#f1efe4',
  signUpPhoneWelcomeText: '#1a1f3f',
  signUpPhoneLoginBoxBG: '#e6e3d4',
  signUpPhoneInputBG: '#e6e3d4',
  signUpPhoneTextInputPrimary: '#1a1f3f',
  signUpPhoneTextInputPlaceHolder: '#1a1f3f',
  signUpPhoneTextUnderlineColor: '#1a1f3f',
  signUpPhoneBottomText: '#7b7e96',
  resendOTP: '#edeffa',

  chatFloatBtnBG: '#27305A',
  chatFloatBtnTitle: '#fff'
};
